import React, { useEffect } from "react";
import { Grid } from "@mui/material";
import { FastField, Field, useFormikContext } from "formik";
import { TextField } from "@mui/material";
import DropdownSelector from "../../atoms/Common/DropdownSelector.tsx";
import { getCatalogue } from "../../api/common/catalogues.ts";
import { LGNumber } from "../../atoms/Inputs/LGNumber.tsx";

export default function ProductFoilForm() {
  const { values, setFieldValue } = useFormikContext() as any;

  // Initialize props structure for FOIL products
  useEffect(() => {
    if (!values.props || values.props.length === 0 || 
        !values.props.some(p => p?.key === "A" || p?.key === "L" || p?.key === "U")) {
      const props = [
        { key: "A", value: "" }, // Ancho
        { key: "L", value: "" }, // Largo
        { key: "U", value: "" }, // Unidad de medida
      ];
      setFieldValue("props", props);
    }
  }, [setFieldValue, values.props]);
  
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Field
          fullWidth
          name="props.0.value"
          label="Ancho (cm)"
          as={LGNumber}
          inputProps={{ step: "0.1" }}
        />
      </Grid>

      <Grid item xs={12}>
        <Field
          fullWidth
          name="props.1.value"
          label="Largo (cm)"
          as={LGNumber}
          inputProps={{ step: "0.1" }}
        />
      </Grid>

      <Grid item xs={12}>
        <FastField
          fullWidth
          name="props.2.value"
          label="Unidad de medida"
          as={DropdownSelector}
          fetchFunction={getCatalogue}
          fetchParams={{ catalogueName: "UNIT", pageSize: 1000 }}
          keyField="id"
        />
      </Grid>
    </Grid>
  );
}

